import { sortBy } from 'lodash';

import agentsResource from 'src/actions/agent/agentsResource';
import useResource from 'src/presentation/hooks/useResource';

export default function useAgents() {
  const { loadingState, values } = useResource(agentsResource, { fetch: false });
  return {
    loadingState,
    values: sortBy(
      values
        .filter(({ disabledAt }) => !disabledAt)
        .map(({ id, email, name }) => {
          return { label: name && name.length ? name : email, value: id };
        }),
      ['label']
    ),
  };
}
